import { User } from "./user";

export class Contact {

    Code!: string;
    Name?: string;
    Email?: string;
    IncId?: number;
    SqlId?: number;
    ClientCode?: string;

    static mapFromJSON(json: any) {
        const c = new Contact();

        c.Code = json['code'];
        c.Name = json['name'];
        c.Email = json['email'];
        c.IncId = json['incId'];
        c.SqlId = json['sqlId'];
        c.ClientCode = json['clientCode'];
        
        return c;
    }
}